// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.order-info-section__sections-wrapper[data-v-58933367] {\n  margin: 0 -15px;\n}\n", ""]);
// Exports
module.exports = exports;
